import React, { Component } from 'react'
import { Select } from 'antd'
import './index.css'

const { Option } = Select

export default class index extends Component {
  render() {
    const { required, title, disabled, value, options } = this.props.item
    return (
      <div className="text-select-view">
        {required && <span className="red-span">*</span>}
        <span
          className={`title-select-class ${
            disabled ? 'disabled-select-title-color' : ''
          }`}
        >
          {title}
        </span>
        <div className="text-select-content-class">
          <Select
            disabled={disabled}
            bordered={false}
            size="large"
            value={options.length > 0 ? (value > 0 ? value : '未选择') : '无'}
            style={{ width: '100%', height: '100%' }}
            options={options}
            onChange={(v, option) => {
              this.props.onSelectChange(v, option)
            }}
          ></Select>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/textSelectView/index.js